<section class="pb-5">
  <h1 class="display-4 my-5"><span class="obrame-txt-hightlight-yellow">Obrame</span> Subscription</h1>
</section>

<section class="obrame-private-section">
  <div class="row justify-content-center">
    <div class="col-md-8 col-lg-6 text-center">

      @if (isLoading) {
        <div class="success-card p-5 rounded-3 shadow-sm">
          <div class="mb-4">
            <fa-icon [icon]="faSpinner" size="3x" animation="spin" class="text-primary"></fa-icon>
          </div>
          <h3 class="fw-normal mb-3">Processing your subscription...</h3>
          <p class="text-body-secondary">Please wait while we confirm your payment.</p>
        </div>
      } @else if (isError) {
        <div class="success-card p-5 rounded-3 shadow-sm border-danger">
          <div class="mb-4">
            <span class="error-icon">&#10007;</span>
          </div>
          <h3 class="fw-normal mb-3">Something went wrong</h3>
          <p class="text-body-secondary">{{ errorMessage }}</p>
          <a routerLink="/profile/subscriptions" class="btn btn-obrame-primary btn-lg mt-3">
            Back to Plans
          </a>
        </div>
      } @else {
        <div class="success-card p-5 rounded-3 shadow-sm">
          <div class="mb-4">
            <fa-icon [icon]="faCircleCheck" size="4x" class="text-success"></fa-icon>
          </div>
          <h2 class="fw-bold mb-3">Payment Successful!</h2>
          <p class="lead text-body-secondary mb-4">
            Thank you for subscribing to Obrame. Your subscription is now active and ready to use.
          </p>
          <p class="text-body-secondary">
            You will receive a confirmation email with the details of your subscription shortly.
          </p>
          <div class="mt-4">
            <a routerLink="/profile/mysubscriptions" class="btn btn-obrame-primary btn-lg">
              View My Subscriptions
            </a>
          </div>
        </div>
      }

    </div>
  </div>
</section>
